import React, {useEffect, useState} from 'react';
import DatasetLineChart from "../dashboard/charts/DatasetLineChart";

export default function DataWindowChart() {
    const [selectedDatasets, setSelectedDatasets] = useState<Array<String>>([]);


    useEffect(() => {
        const onDatasetSel = () => {
            const sel = PF('datasetsTable').selection as Array<String>;
            console.log(`Dataset select: ${sel}`);

            setSelectedDatasets([...sel])
        }

        window.addEventListener("datasetSelectionChange", onDatasetSel, false);
        return () => {
            window.removeEventListener("datasetSelectionChange", onDatasetSel, false)
        }
    });

    return <>
        { selectedDatasets.length == 0 &&
            <h2>No datasets selected</h2>
        }

        { selectedDatasets.length > 0 &&
            <DatasetLineChart identifiers={selectedDatasets} showDateSelection hideRefresh height={560} dynamicHeight={true}/>
        }
    </>
}